export function productCategoryMapperListResponse(json, headers) {
  return {
    data: json.map((resource) => ({
      ...resource,
      id: resource.objectId,
      categoryId: resource.objectId,
    })),
    total: headers.get("X-Total-Count") ? parseInt(headers.get("X-Total-Count").split("/").pop(), 10) : 1000,
  };
}

export function fixUpdateProductCategoryId(json) {
  return {
    data: {...json.result, id: json.result.objectId},
  };
}

export function fixGetManyProductCategories(json) {
  return {
    data: json.map((resource) => ({
      ...resource,
      id: resource.objectId,
      categoryId: resource.objectId,
    })),
  };
}

export function fixCreateProductCategoryId(params, json) {
  return {
    data: {...json.result, id: json.result.objectId, categoryId: json.result.objectId},
  };
}

export function productCategoryMapperGetOneResponse(json) {
  return {
    data: {...json.result, id: json.result.objectId},
  };
}